import axios from 'axios';

class APIClient {
  constructor() {
    const service = axios.create();
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
    this.basePath = process.env.REACT_APP_API_URL;
    this.jwtLocation = process.env.REACT_APP_LOCAL_JWT;
    this.organization = this.getOrganization();
    this.jwt = this.getJWTToken();
    this.apiHeaders = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.jwt}`,
        Organization: this.organization,
      },
    };
  }

  getJWTToken = () => {
    if (process.env.REACT_APP_JWT_TOKEN) {
      return process.env.REACT_APP_JWT_TOKEN;
    }

    let jwtToken = '';
    Object.keys(localStorage).forEach((key) => {
      try {
        const values = JSON.parse(localStorage[key]);
        if (
          values?.secret &&
          values?.credentialType?.toString().toLowerCase() === 'idtoken'
        ) {
          jwtToken = values.secret;
        }
      } catch (e) {
        if (key === this.jwtLocation && jwtToken === '') {
          jwtToken = localStorage[key];
        }
      }
    });

    return jwtToken;
  };

  // eslint-disable-next-line class-methods-use-this
  getOrganization = () => {
    let organization = 'US';
    Object.keys(localStorage).forEach((key) => {
      if (key === 'Organization') {
        organization = localStorage[key];
      }
    });

    return organization;
  };

  // eslint-disable-next-line class-methods-use-this
  handleSuccess = (response) => {
    return response;
  };

  // eslint-disable-next-line class-methods-use-this
  handleError = (error) => {
    return Promise.reject(error);
  };

  validateSerial(serial, callback) {
    this.service
      .get(
        `${this.basePath}/v2/serials/${serial}/clubs?registeredBottom=true`,
        this.apiHeaders
      )
      .then((response) => {
        callback(response.status, response);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  }

  getAllSerials(callback) {
    this.service
      .get(`${this.basePath}/v2/registered/serials`, this.apiHeaders)
      .then((response) => {
        callback(response.status, response);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  }

  registerClubs = async (clubs, callback) => {
    await this.service
      .post(`${this.basePath}/v2/clubs`, { clubs }, this.apiHeaders)
      .then((response) => {
        callback(response?.status);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  };

  unregisterSerialNumber = async (serialNumber, callback) => {
    await this.service
      .delete(
        `${this.basePath}/v2/registered/serials/${serialNumber}`,
        this.apiHeaders
      )
      .then((response) => {
        callback(response.status);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  };

  unregisterSerialHeaderKey = async (serialHeaderKey, callback) => {
    await this.service
      .delete(
        `${this.basePath}/v2/registered/headers/${serialHeaderKey}`,
        this.apiHeaders
      )
      .then((response) => {
        callback(response.status);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  };

  unregisterMasterSerialNumber = async (masterSerialNumber, callback) => {
    await this.service
      .delete(
        `${this.basePath}/v2/registered/masters/${masterSerialNumber}`,
        this.apiHeaders
      )
      .then((response) => {
        callback(response.status);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  };
}

export default new APIClient();
